import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { OfficeStatus } from '../../../../../../shared/office-status';
import { BrandService } from '../../../../../../services/brand.service';
import { BestService } from '../../../../../../services/best.service';
import { FruHttpService } from '../../../../../../services/fru-http.service';
import { AnalyticsService } from '../../../../../../services/analytics.service';

@Component({
    selector: 'app-best-landing-footer',
    templateUrl: './best-landing-footer.component.html',
    styleUrls: ['./best-landing-footer.component.scss'],
    standalone: false
})
export class BestLandingFooterComponent implements OnInit {
  public lenderPhoneStatus: OfficeStatus;
  
  public currentYear: number = 2023;

	public recommendedLenderActive: boolean = false;
  isSecureForm: boolean = false;
  isTop10newFooterForm: boolean = false;

  constructor(
  	public brandService: BrandService,
  	public best: BestService,
  	private fruHttp: FruHttpService,
    private route: ActivatedRoute,
    public analyticsService: AnalyticsService
  ) {
    if(this.route.snapshot.queryParams['recommendedLender'] === 'true') {
			this.recommendedLenderActive = true;
		}

    if (this.brandService.domain.includes('top10bestlenders')) {
      this.isTop10newFooterForm = true;
    }

    this.analyticsService.getExperiments().subscribe(
      (variationData: any) => {
        this.isSecureForm = variationData.enabledVariations.hasOwnProperty('secureForm');
      }
    );
  }

  ngOnInit() {
    let d = new Date();
    this.currentYear = d.getFullYear();
  }

  ngAfterViewInit() {
    if(this.best.lender) {
      this.fruHttp.getLenderPhone(this.best.lender, 'top_10').subscribe(lenderPhoneStatus => this.lenderPhoneStatus = lenderPhoneStatus);
    } else {
      this.route.queryParams.subscribe(params => {
        if (typeof params.l !== 'undefined' && params.l !== '') {
          this.fruHttp.getLenderPhone(params.l, 'top_10').subscribe(lenderPhoneStatus => this.lenderPhoneStatus = lenderPhoneStatus);
        } else {
          this.fruHttp.getLenderPhone('0', 'top_10').subscribe(lenderPhoneStatus => this.lenderPhoneStatus = lenderPhoneStatus);
        }
      });
    }
  }

}
